import request from '@/utils/request'

export function applyDomainList(query) {
  return request({
    url: '/cms/apply_domain/list',
    method: 'get',
    params: query
  })
}
export function indexBannerList(query) {
  return request({
    url: '/cms/banner/list',
    method: 'get',
    params: query
  })
}
export function getProductTree(query) {
  return request({
    url: '/cms/product_type/tree',
    method: 'get',
    params: query
  })
}
export function getProductList(data,query) {
  return request({
    url: '/cms/product/list?pageNum='+query.pageNum+'&pageSize='+query.pageSize,
    method: 'post',
    data: data,
  })
}
export function getProductVideoList(query) {
  return request({
    url: '/cms/video/product/list',
    method: 'get',
    params: query
  })
}
export function getProductDetail(id) {
  return request({
    url: '/cms/product/'+id,
    method: 'get',
  })
}
export function getApplyList(query) {
  return request({
    url: '/cms/apply_domain/list',
    method: 'get',
    params: query
  })
}
export function getApplyPlanList(query) {
  return request({
    url: '/cms/apply_plan/list',
    method: 'get',
    params: query
  })
}
export function getApplyDetail(id) {
  return request({
    url: '/cms/apply_plan/'+id,
    method: 'get',
  })
}
export function getNewsList(query) {
  return request({
    url: '/cms/news/list',
    method: 'get',
    params: query
  })
}
export function getMarketList(query) {
  return request({
    url: '/cms/market/list',
    method: 'get',
    params: query
  })
}
export function getDictList(type) {
  return request({
    url: '/system/dict/data/type/'+type,
    method: 'get',
  })
}
export function getRecruitmentList(query) {
  return request({
    url: '/cms/recruitment/list',
    method: 'get',
    params: query
  })
}
export function getRecruitmentDetail(id) {
  return request({
    url: '/cms/recruitment/'+id,
    method: 'get',
  })
}
export function getVideoList(query) {
  return request({
    url: '/cms/video/list',
    method: 'get',
    params: query
  })
}

export function getVideoDetail(id) {
  return request({
    url: '/cms/video/'+id,
    method: 'get',
  })
}
// 查询产品销售
export function getProductSales(query) {
  return request({
    url: '/cms/sale/list',
    method: 'get',
    params: query
  })
}

// 查询产品技术手册
export function getProductManuals(query) {
  return request({
    url: '/cms/manual/list',
    method: 'get',
    params: query
  })
}

// 下载
export function downloadFile(query) {
  return request({
    url: '/common/download/resource',
    method: 'get',
    params: query,
  })
}

// 销售列表
export function getMarket(query) {
  return request({
    url: '/cms/market/list',
    method: 'get',
    params: query,
  })
}

// 文章详情
export function getNewsDetail(id) {
  return request({
    url: '/cms/news/'+id,
    method: 'get',
  })
}

// 文章文件列表
export function getNewsZlglList(query) {
  return request({
    url: '/cms/quality-file/list',
    method: 'get',
    params:query
  })
}

// 文章文件列表
export function getZlglList(query) {
  return request({
    url: '/cms/quality-reliability/list',
    method: 'get',
    params:query
  })
}
// 查看产品销售信息
export function getProductOrderList(params) {
  return request({
    url: '/cms/subscribe_info/list',
    method: 'get',
    params:params
  })
}
export function getProductOrderTable() {
  return request({
    url: '/cms/subscribe_info_col/list',
    method: 'get',
  })
}
export function getProductTypeList(params) {
  return request({
    url: '/cms/product_attr/list',
    method: 'get',
    params:params
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js